import React, { useCallback, useEffect, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { TimeFilter } from '../filters/TimeFilter';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {TimeField} from '@mui/x-date-pickers';
import { debounce } from 'lodash';

type Section = 'hours' | 'minutes' | null;

export const SPTimeField: FieldComponent<any, any> = ({
  onChange,
  defaultValue,
  forcedValue,
  disabled,
  isMissing,
}) => {

  const [section, setSection] = useState<Section>(null);
  const [currentState, setCurrentState] = useState<any>({
    value: null,
    send: false,
  });

  const debouncedChange = useCallback(
    debounce((newValue) => {
      onChange(newValue);
    }, 300),
    []
  );

  useEffect(() => {
    if (defaultValue) {
      setCurrentState({
        value: dayjs(defaultValue, 'HH:mm'),
        send: false,
      });
    }
  }, [defaultValue]);

  useEffect(() => {
    if (currentState.send) {
      debouncedChange(currentState.value);
    }
  }, [currentState, debouncedChange]);

  const handleChange = (value: any) => {
    setCurrentState({
      value: value,
      send: true,
    });
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimeField
          sx={{
            width: '100%'
          }}
          disabled={disabled}
          slotProps={{ textField: { size: 'small' } }}
          ampm={false}
          defaultValue={dayjs(defaultValue, 'HH:mm')}
          onChange={(newValue: any) => {
            const datetime = dayjs(newValue, 'HH:mm').format('HH:mm');
            if (datetime !== 'Invalid Date') {
              handleChange(dayjs(newValue, 'HH:mm').format('HH:mm'));
            } else {
              handleChange(null);
            }
          }}

          selectedSections={section}             // <— aktív szekció
          onSelectedSectionsChange={(s) => setSection(s as Section)}
          onKeyDown={(e) => {
            if (e.key === 'Tab' && !e.shiftKey && (section === null || section === 'hours')) {
              e.preventDefault();
              setSection('minutes');             // Tab: hours → minutes
            } else if (e.key === 'Tab' && e.shiftKey && section === 'minutes') {
              e.preventDefault();
              setSection('hours');               // Shift+Tab: minutes → hours
            }
          }}
        />
      </LocalizationProvider>
    </>
  );
};

SPTimeField.includes = (query, value) => true;

SPTimeField.comparator = () => 0;

SPTimeField.FilterRenderer = TimeFilter;
